var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: "Recette" + _vm.keyRecette },
    [
      _c("ModalFavorisRecette", {
        ref: "modalFavorisRecette",
        on: {
          favorisChoisis: function($event) {
            return _vm.setFavoris($event)
          }
        }
      }),
      _c(
        "b-form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-xxl-7" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "form-group col-12 col-md-6 mb-0 pr-1" },
                    [
                      _c("label", { attrs: { for: "nomRecette" } }, [
                        _vm._v("Titre interne")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.recette.nom,
                            expression: "recette.nom",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "nomRecette",
                          readonly: _vm.recette.lectureSeule,
                          placeholder: "Titre interne"
                        },
                        domProps: { value: _vm.recette.nom },
                        on: {
                          change: function($event) {
                            return _vm.copyNom()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.recette,
                              "nom",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      !_vm.$v.recette.nom.required && !_vm.spinnerShown
                        ? _c("div", { staticClass: "error" }, [
                            _vm._v("Ce champ est requis")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "form-group col-12 col-md-6 mb-0 pl-1" },
                    [
                      _c("label", { attrs: { for: "nomCommercialRecette" } }, [
                        _vm._v("Titre public")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.recette.nomCommercial,
                            expression: "recette.nomCommercial"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "nomCommercialRecette",
                          readonly: _vm.recette.lectureSeule,
                          placeholder: "Titre public"
                        },
                        domProps: { value: _vm.recette.nomCommercial },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.recette,
                              "nomCommercial",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-6" }, [
                    _c("div", { staticClass: "row" }, [
                      !_vm.recette.lectureSeule
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-6 form-group pr-1 mb-0"
                            },
                            [
                              _c("label", { attrs: { for: "pourNombre" } }, [
                                _vm._v("Pour")
                              ]),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.recette.pourNombre,
                                    expression: "recette.pourNombre",
                                    modifiers: { trim: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "number",
                                  id: "pourNombre",
                                  "aria-describedby": "nombre",
                                  placeholder: "Nombre",
                                  step: "1",
                                  lang: "fr",
                                  min: "0"
                                },
                                domProps: { value: _vm.recette.pourNombre },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.recette,
                                      "pourNombre",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              }),
                              _vm.inputForPersonsIntegerRequired &&
                              !_vm.spinnerShown
                                ? _c("div", { staticClass: "error" }, [
                                    _vm._v(
                                      "Les personnes doivent être des nombres entiers"
                                    )
                                  ])
                                : _vm._e(),
                              !_vm.$v.recette.pourNombre.required &&
                              !_vm.spinnerShown
                                ? _c("div", { staticClass: "error" }, [
                                    _vm._v("Ce champ est requis")
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _c("span", { staticClass: "col-12 col-md-6 pr-1" }, [
                            _vm._v("Pour " + _vm._s(_vm.recette.pourNombre))
                          ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-6 form-group pl-1 pr-1 mb-0"
                        },
                        [
                          _c("label", { attrs: { for: "uniteProduction" } }, [
                            _vm._v("Unité de production")
                          ]),
                          _c("v-select", {
                            attrs: {
                              disabled: _vm.recette.lectureSeule,
                              id: "uniteProduction",
                              options: _vm.optionsUniteDeProductions,
                              label: "text",
                              value: "value",
                              clearable: false
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkIfQuantitesParAssietteExists(
                                  $event.value
                                )
                              }
                            },
                            model: {
                              value: _vm.uniteDeProductionSelectionnee,
                              callback: function($$v) {
                                _vm.uniteDeProductionSelectionnee = $$v
                              },
                              expression: "uniteDeProductionSelectionnee"
                            }
                          }),
                          !_vm.$v.recette.up.required && !_vm.spinnerShown
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v("Ce champ est requis")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 col-md-12 pr-1 form-group mb-0"
                        },
                        [
                          _c("label", { attrs: { for: "uniteProduction" } }, [
                            _vm._v("Zone de préparation")
                          ]),
                          _c("v-select", {
                            attrs: {
                              disabled: _vm.recette.lectureSeule,
                              options: _vm.zonesPreparations,
                              label: "text",
                              value: "value",
                              clearable: false
                            },
                            on: {
                              input: function($event) {
                                return _vm.changeZonePreparation(
                                  _vm.recette,
                                  _vm.zonePreparationSelectionnee.value
                                )
                              }
                            },
                            model: {
                              value: _vm.zonePreparationSelectionnee,
                              callback: function($$v) {
                                _vm.zonePreparationSelectionnee = $$v
                              },
                              expression: "zonePreparationSelectionnee"
                            }
                          }),
                          !_vm.recette.zonePreparationId && !_vm.spinnerShown
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v("Ce champ est requis")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col-12 col-md-6" }, [
                    _vm.qteTypeforPersons
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-12 form-group pl-1 mb-0"
                            },
                            [
                              _c(
                                "label",
                                { attrs: { for: "uniteProduction" } },
                                [_vm._v("Type de convive")]
                              ),
                              _c("v-select", {
                                attrs: {
                                  disabled: _vm.recette.lectureSeule,
                                  options: _vm.optionsConviveType,
                                  label: "text",
                                  value: "value",
                                  clearable: false
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.changeTypeConvive(
                                      _vm.recette,
                                      $event.value
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.typeConviveSelectionne,
                                  callback: function($$v) {
                                    _vm.typeConviveSelectionne = $$v
                                  },
                                  expression: "typeConviveSelectionne"
                                }
                              }),
                              !_vm.recette.conviveTypeId && !_vm.spinnerShown
                                ? _c("div", { staticClass: "error" }, [
                                    _vm._v("Ce champ est requis")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 col-md-12 form-group pl-1 mb-0"
                        },
                        [
                          _c("label", { attrs: { for: "uniteProduction" } }, [
                            _vm._v("Catégorie")
                          ]),
                          _c("v-select", {
                            attrs: {
                              disabled: _vm.recette.lectureSeule,
                              options: _vm.categorieRecettes,
                              label: "text",
                              value: "value",
                              clearable: false
                            },
                            on: {
                              input: function($event) {
                                return _vm.changeCategorieRecette(
                                  _vm.recette,
                                  _vm.categorieRecetteSelectionnee.value
                                )
                              }
                            },
                            model: {
                              value: _vm.categorieRecetteSelectionnee,
                              callback: function($$v) {
                                _vm.categorieRecetteSelectionnee = $$v
                              },
                              expression: "categorieRecetteSelectionnee"
                            }
                          }),
                          !_vm.recette.categorieRecetteId && !_vm.spinnerShown
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v(" Ce champ est requis ")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _vm._v(" Ingrédients ")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "card-content",
                      attrs: { "aria-expanded": "true" }
                    },
                    [
                      _c("div", {}, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12" },
                          [
                            _c("RechercheCompleteProduits", {
                              ref: "recherche",
                              attrs: {
                                placeHolder:
                                  "Rechercher un produit, un ingrédient ou une recette...",
                                selectionActive: false,
                                chercherProduits: true,
                                chercherIngredients: true,
                                chercherRecettes: true,
                                pourChoixIngredient: true,
                                afficherPrix: true
                              },
                              on: {
                                input: function($event) {
                                  return _vm.ajouterLigneIngredient($event)
                                }
                              }
                            }),
                            _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                { staticClass: "table" },
                                [
                                  _vm.recette.lignes &&
                                  _vm.recette.lignes.length
                                    ? _c(
                                        "draggable",
                                        {
                                          key: _vm.recette.lignes.length,
                                          attrs: {
                                            disabled: _vm.recette.lectureSeule,
                                            ordre: ".ordre",
                                            tag: "tbody"
                                          },
                                          on: {
                                            end: function($event) {
                                              _vm.choixFamilleKey += 1
                                            }
                                          },
                                          model: {
                                            value: _vm.compRecetteLignes,
                                            callback: function($$v) {
                                              _vm.compRecetteLignes = $$v
                                            },
                                            expression: "compRecetteLignes"
                                          }
                                        },
                                        _vm._l(_vm.compRecetteLignes, function(
                                          ligne,
                                          index
                                        ) {
                                          return _c(
                                            "tr",
                                            {
                                              key: index,
                                              staticStyle: { cursor: "grab" }
                                            },
                                            [
                                              _c(
                                                "td",
                                                [
                                                  _c("dropDownChoixFamille", {
                                                    key: _vm.choixFamilleKey,
                                                    attrs: {
                                                      familleSelectionnee:
                                                        ligne.famille,
                                                      familles:
                                                        (_vm.recette
                                                          .lectureSeule &&
                                                          []) ||
                                                        (ligne.familleId &&
                                                          _vm.famillesPour(
                                                            ligne
                                                          )) ||
                                                        [],
                                                      ingredient: ligne,
                                                      afficherTexte: true
                                                    },
                                                    on: {
                                                      "select-famille": function(
                                                        $event
                                                      ) {
                                                        return _vm.setFamille(
                                                          $event,
                                                          ligne
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c("td", [
                                                ligne.composant &&
                                                ligne.composant.produits ===
                                                  undefined &&
                                                !ligne.familleId
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "RecettePopUpIngredients",
                                                          {
                                                            class: {
                                                              warningText: _vm.estSansCotation(
                                                                ligne
                                                              )
                                                            },
                                                            attrs: {
                                                              estLien:
                                                                _vm.lienRecetteActif,
                                                              recetteId:
                                                                ligne.composant
                                                                  .id,
                                                              recetteNom:
                                                                ligne.composant
                                                                  .nom,
                                                              estDeclinaisonNonPersonnalisee:
                                                                ligne.composant
                                                                  .estUneDeclinaison &&
                                                                !ligne.composant
                                                                  .estDeclinaisonPersonnalisee
                                                            },
                                                            on: {
                                                              "recette-enregistree": function(
                                                                $event
                                                              ) {
                                                                return _vm.recetteEnregistree(
                                                                  ligne,
                                                                  $event
                                                                )
                                                              }
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          warningText: _vm.estSansCotation(
                                                            ligne
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              ligne.composant &&
                                                                ligne.composant
                                                                  .nom
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                              ]),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "flex-center",
                                                  staticStyle: {
                                                    "padding-top":
                                                      "16px !important"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        width: "70px"
                                                      }
                                                    },
                                                    [
                                                      !_vm.recette.lectureSeule
                                                        ? _c("InputNumber", {
                                                            key: ligne.id,
                                                            ref:
                                                              "field-" + index,
                                                            refInFor: true,
                                                            attrs: {
                                                              id: ligne.id,
                                                              readonly:
                                                                _vm.recette
                                                                  .lectureSeule,
                                                              typeFiltre:
                                                                "quantite"
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                return _vm.ingredientQuantite(
                                                                  index,
                                                                  ligne
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                ligne.quantite,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  ligne,
                                                                  "quantite",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "ligne.quantite"
                                                            }
                                                          })
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                ligne.quantite
                                                              )
                                                            )
                                                          ])
                                                    ],
                                                    1
                                                  ),
                                                  ligne.composant &&
                                                  ligne.composant.produits &&
                                                  ligne.composant.produits
                                                    .length &&
                                                  ligne.UPs &&
                                                  ligne.UPs.length > 1 &&
                                                  !_vm.recette.lectureSeule
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center"
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            staticStyle: {
                                                              "min-width":
                                                                "70px"
                                                            },
                                                            attrs: {
                                                              options:
                                                                ligne.UPs,
                                                              clearable: false
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                return _vm.setUniteDeProduction(
                                                                  $event,
                                                                  ligne
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value: ligne.up,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  ligne,
                                                                  "up",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "ligne.up"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : ligne.composant &&
                                                      ligne.composant
                                                        .produits &&
                                                      ligne.composant.produits
                                                        .length &&
                                                      ligne.cotationManquante &&
                                                      !_vm.recette.lectureSeule
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center"
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            attrs: {
                                                              options:
                                                                _vm.optionsUp,
                                                              clearable: false
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                return _vm.setUniteDeProduction(
                                                                  $event,
                                                                  ligne
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value: ligne.up,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  ligne,
                                                                  "up",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "ligne.up"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ligne-up-unique"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(ligne.up) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                  _vm.gramPossiblePourLigne(
                                                    ligne
                                                  ) &&
                                                  _vm.gramPossiblePourLigne(
                                                    ligne
                                                  ).length > 1 &&
                                                  ligne.up === "PCE"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center"
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.recette
                                                                  .lectureSeule,
                                                              options: _vm.gramPossiblePourLigne(
                                                                ligne
                                                              ),
                                                              clearable: false
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                return _vm.setGram(
                                                                  $event,
                                                                  ligne
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                ligne.grammage,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  ligne,
                                                                  "grammage",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "ligne.grammage"
                                                            }
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "10px"
                                                              }
                                                            },
                                                            [_vm._v("g")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  ligne.up === "PCE" &&
                                                  ligne.familleId &&
                                                  ligne.conviveTypeId
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "10px"
                                                          }
                                                        },
                                                        [_vm._v("pour")]
                                                      )
                                                    : _vm._e(),
                                                  ligne.up === "PCE" &&
                                                  ligne.familleId &&
                                                  ligne.conviveTypeId
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c("v-select", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.recette
                                                                  .lectureSeule,
                                                              options:
                                                                _vm.optionsConviveType,
                                                              label: "text",
                                                              value: "value",
                                                              clearable: false
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                return _vm.setConvive(
                                                                  $event.value,
                                                                  ligne
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                ligne.typeConviveSelectionne,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  ligne,
                                                                  "typeConviveSelectionne",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "ligne.typeConviveSelectionne"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              ligne.estEnCalculPrix
                                                ? _c("td", [
                                                    _c("img", {
                                                      staticStyle: {
                                                        height: "45px"
                                                      },
                                                      attrs: {
                                                        alt: "en attente",
                                                        src:
                                                          "/assets/images/spinners/cooking-blue-court.gif"
                                                      }
                                                    })
                                                  ])
                                                : _c("td", [
                                                    ligne.quantite &&
                                                    ligne.famille &&
                                                    ligne.composant &&
                                                    ligne.composant.estPerso ===
                                                      undefined
                                                      ? _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: {
                                                                  content: _vm.detailsFournisseurs(
                                                                    ligne.details,
                                                                    ligne.erreurs
                                                                  ),
                                                                  classes:
                                                                    "tooltip-details-fournisseurs"
                                                                },
                                                                expression:
                                                                  "{ content: detailsFournisseurs(ligne.details,ligne.erreurs),                              classes: 'tooltip-details-fournisseurs' }"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "nowrap"
                                                          },
                                                          [
                                                            ligne.prixUnitaire
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle: {
                                                                      "margin-left":
                                                                        "20px",
                                                                      "margin-right":
                                                                        "20px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.affichePrixIngredient(
                                                                            ligne,
                                                                            ligne.prixUnitaire,
                                                                            ligne.quantite
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    ligne.erreurs
                                                                      ? _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-exclamation"
                                                                          }
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    ligne.composant &&
                                                    !ligne.famille
                                                      ? _c("div", [
                                                          ligne.prixUnitaire
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "20px",
                                                                    "margin-right":
                                                                      "20px"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.affichePrixIngredient(
                                                                          ligne,
                                                                          ligne.prixUnitaire,
                                                                          ligne.quantite
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ])
                                                      : _vm._e(),
                                                    _vm.estSansCotation(ligne)
                                                      ? _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: {
                                                                  content: _vm.detailsFournisseurs(
                                                                    ligne.details,
                                                                    ligne.erreurs
                                                                  ),
                                                                  classes:
                                                                    "tooltip-details-fournisseurs"
                                                                },
                                                                expression:
                                                                  "{ content: detailsFournisseurs(ligne.details,ligne.erreurs),                              classes: 'tooltip-details-fournisseurs' }"
                                                              }
                                                            ],
                                                            class: {
                                                              warningText: _vm.estSansCotation(
                                                                ligne
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Indisponible "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    ligne.nonCommandable
                                                      ? _c("div", {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "20px"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]),
                                              !_vm.profilIsAdmin
                                                ? _c(
                                                    "td",
                                                    [
                                                      !ligne.nonCommandable &&
                                                      !(
                                                        ligne.composant &&
                                                        ligne.composant
                                                          .produits ===
                                                          undefined &&
                                                        !ligne.familleId
                                                      )
                                                        ? _c("ToggleButton", {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value: {
                                                                  content:
                                                                    (ligne.estACommander
                                                                      ? "P"
                                                                      : "Ne pas p") +
                                                                    "rendre en compte cette ligne pour le calcul des besoins lors la génération de commandes",
                                                                  placement:
                                                                    "bottom"
                                                                },
                                                                expression:
                                                                  "{content: (ligne.estACommander ? 'P' : 'Ne pas p') + 'rendre en compte cette ligne pour le calcul des besoins lors la génération de commandes', placement: 'bottom'}"
                                                              }
                                                            ],
                                                            attrs: {
                                                              labels: {
                                                                checked:
                                                                  "Commander",
                                                                unchecked:
                                                                  "Ne pas commander"
                                                              },
                                                              color: {
                                                                checked:
                                                                  "#025DBF",
                                                                unchecked:
                                                                  "#CCCCCC"
                                                              },
                                                              height: 25,
                                                              width: 150
                                                            },
                                                            model: {
                                                              value:
                                                                ligne.estACommander,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  ligne,
                                                                  "estACommander",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "ligne.estACommander"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          ligne.up === "PCE" &&
                                                          !_vm.recette
                                                            .lectureSeule,
                                                        expression:
                                                          "ligne.up === 'PCE' && !recette.lectureSeule"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "btn btn-primary",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.dupliquerLigneIngredient(
                                                          ligne
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fas fa-copy"
                                                    })
                                                  ]
                                                )
                                              ]),
                                              _c("td", [
                                                !ligne.nonCommandable &&
                                                !(
                                                  ligne.composant &&
                                                  ligne.composant.produits ===
                                                    undefined &&
                                                  !ligne.familleId
                                                )
                                                  ? _c(
                                                      "button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value: {
                                                              content:
                                                                "Gerer les favoris de recette sur les articles liés à l'ingrédient"
                                                            },
                                                            expression:
                                                              "{ content: 'Gerer les favoris de recette sur les articles liés à l\\'ingrédient'}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "btn btn-primary",
                                                        attrs: {
                                                          type: "button"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.afficherDetailIngredient(
                                                              ligne
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-star"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]),
                                              _c("td", [
                                                !_vm.recette.lectureSeule
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-danger",
                                                        attrs: {
                                                          type: "button",
                                                          "aria-label":
                                                            "Supprimer cet ingrédient"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.supprimerRecetteLigne(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-trash"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ])
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm.recette.lignes &&
                                  _vm.recette.lignes.length
                                    ? _c("tr", { attrs: { scope: "row" } }, [
                                        _c("td", { attrs: { colspan: "12" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-center-space-between pt-3"
                                            },
                                            [
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(_vm.totalParPersonne)
                                                  )
                                                ])
                                              ]),
                                              _c("div", [
                                                _c("b", [
                                                  _vm._v(
                                                    "TOTAL " +
                                                      _vm._s(
                                                        _vm.setTotal(
                                                          _vm.recette.lignes
                                                        )
                                                      )
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              !_vm.recette.lignes || !_vm.recette.lignes.length
                                ? _c("div", { staticClass: "error ml-2" }, [
                                    _vm._v(
                                      "Au moins un ingrédient est nécessaire"
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-header flex-center-space-between" },
                    [
                      _c("span", [_vm._v("Quantités par assiette")]),
                      _c("span", [
                        _vm._v("(Denrée principale sans sauce, sans garniture)")
                      ]),
                      !_vm.recette.lectureSeule
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger btn-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.effacerQuantitesParAssiette()
                                }
                              }
                            },
                            [_vm._v("Effacer")]
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "card-content",
                      attrs: { "aria-expanded": "true" }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "div",
                          {
                            key: _vm.keyQuantites,
                            staticClass: "col-xs-12",
                            style: _vm.quantitesParAssietteValides
                              ? ""
                              : "border:1px solid red;padding:1px;"
                          },
                          [
                            !_vm.recette.lectureSeule
                              ? _c("v-select", {
                                  attrs: {
                                    disabled:
                                      _vm.optionsConvivesDisponibles.length ===
                                      0,
                                    options: _vm.optionsConvivesDisponibles,
                                    label: "text",
                                    value: "Ajouter un type de convive...",
                                    clearable: false
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.addQuantitesParAssietteRow(
                                        $event.value,
                                        true
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "no-options",
                                        fn: function() {
                                          return [
                                            _vm._v(
                                              " Tous les types de convive sont utilisés "
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    351091840
                                  )
                                })
                              : _vm._e(),
                            _vm.recette.up && !_vm.qteTypeforPersons
                              ? _c(
                                  "div",
                                  { staticClass: "badge badge-warning" },
                                  [
                                    _vm._v(
                                      "Cette recette étant définie par " +
                                        _vm._s(_vm.recette.up) +
                                        ", les quantités de ce tableau ne seront pas utilisées pour les calculs de production"
                                    )
                                  ]
                                )
                              : _vm.toutesLignesParPiece
                              ? _c(
                                  "div",
                                  { staticClass: "badge badge-warning" },
                                  [
                                    _vm._v(
                                      "Cette recette étant déclinée par convive, les quantités de ce tableau ne seront pas utilisées pour les calculs de production"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-sm table-bordered text-center mt-2"
                              },
                              [
                                _c("thead", [
                                  _c(
                                    "tr",
                                    _vm._l(_vm.servicesHeadings, function(
                                      service
                                    ) {
                                      return _c("th", { key: service.value }, [
                                        _c("div", [_vm._v(_vm._s(service))])
                                      ])
                                    }),
                                    0
                                  )
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.quantitesParAssietteAAfficher,
                                    function(convive, indexConvive) {
                                      return _c(
                                        "tr",
                                        { key: indexConvive },
                                        [
                                          _c("td", [
                                            _vm._v(
                                              " " +
                                                _vm._s(convive.typeConviveNom) +
                                                " "
                                            )
                                          ]),
                                          _vm._l(convive.services, function(
                                            service,
                                            indexService
                                          ) {
                                            return _c(
                                              "td",
                                              {
                                                key: indexService,
                                                style: _vm.recette.lectureSeule
                                                  ? "background-color:#efefef;"
                                                  : ""
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "from-group flex-center-space-between"
                                                  },
                                                  [
                                                    !_vm.recette.lectureSeule
                                                      ? _c("InputNumber", {
                                                          class:
                                                            "form-control " +
                                                            (service.serviceId ===
                                                            convive.base100
                                                              ? "border-base100"
                                                              : "border-classique"),
                                                          attrs: {
                                                            id:
                                                              "service" +
                                                              service.serviceId +
                                                              "-" +
                                                              convive.typeConviveId,
                                                            typeFiltre:
                                                              "quantite"
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              _vm.setServiceQuantite(
                                                                Number($event),
                                                                convive.typeConviveId,
                                                                service.serviceId
                                                              )
                                                            },
                                                            move:
                                                              _vm.moveGrammage
                                                          },
                                                          model: {
                                                            value:
                                                              service.quantite,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                service,
                                                                "quantite",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "service.quantite"
                                                          }
                                                        })
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "11px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                service.quantite
                                                                  ? service.quantite +
                                                                      " g"
                                                                  : ""
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                    service.quantite &&
                                                    !_vm.recette.lectureSeule
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "input-group-text"
                                                          },
                                                          [_vm._v("g")]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "price" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.prixParAssiette(
                                                            service.quantite
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          !_vm.recette.lectureSeule
                                            ? _c("td", [
                                                !_vm.recette.lectureSeule &&
                                                _vm.recette.conviveTypeId !==
                                                  convive.typeConviveId
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-danger btn-sm",
                                                        attrs: {
                                                          type: "button",
                                                          title:
                                                            "Supprimer cette ligne",
                                                          "aria-label":
                                                            "Supprimer cette ligne"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeQuantitesParAssietteRow(
                                                              convive.typeConviveId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-trash"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ])
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            ),
                            !_vm.quantitesParAssietteValides
                              ? _c("div", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    " Veuillez renseigner au moins une quantité par assiette "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-xxl-5" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _vm._v(" Marche à suivre ")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "card-content",
                      attrs: { "aria-expanded": "true" }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12" },
                          [
                            _c("div", {
                              staticClass: "text-left push-top-1rem"
                            }),
                            !_vm.recette.lectureSeule
                              ? _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: _vm.recette.preparation,
                                    callback: function($$v) {
                                      _vm.$set(_vm.recette, "preparation", $$v)
                                    },
                                    expression: "recette.preparation"
                                  }
                                })
                              : _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.recette.preparation)
                                  }
                                }),
                            _c("hr"),
                            _c("BoutonGestionBarquettes", {
                              attrs: {
                                listeBarquetteSelectionnee:
                                  _vm.recette.barquettes,
                                listeBarquette: _vm.listeBarquettes
                              },
                              on: { enregistrer: _vm.enregistrerBarquettes }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]),
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _vm._v(" Compatibilités ")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "card-content",
                      attrs: { "aria-expanded": "true" }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "col-xs-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group mb-0" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "selTexturesIncompatibles" } },
                                [_vm._v("Textures incompatibles")]
                              ),
                              _c("MultiSelect", {
                                attrs: {
                                  id: "selTexturesIncompatibles",
                                  disabled: _vm.recette.lectureSeule,
                                  value: _vm.recette.textureIds,
                                  items: _vm.texturesPourExclusion,
                                  placeholder: "Textures...",
                                  emptyText:
                                    "Toutes les textures ont été ajoutées"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.recette.textureIds = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "form-group mb-0" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "selRegimesIncompatibles" } },
                                [_vm._v("Régimes alimentaires incompatibles")]
                              ),
                              _c("MultiSelect", {
                                attrs: {
                                  id: "selRegimesIncompatibles",
                                  disabled: _vm.recette.lectureSeule,
                                  value: _vm.recette.regimeIds,
                                  items: _vm.regimesPourExclusion,
                                  placeholder: "Régimes alimentaires...",
                                  emptyText: "Tous les régimes ont été ajoutés"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.recette.regimeIds = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "form-group mb-0" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "selComposRepas" } },
                                [_vm._v("Composantes de repas")]
                              ),
                              _c("MultiSelect", {
                                attrs: {
                                  id: "selComposRepas",
                                  disabled: _vm.recette.lectureSeule,
                                  value: _vm.recette.composanteMenuIds,
                                  items: _vm.composantesRepas,
                                  placeholder: "Composantes...",
                                  emptyText:
                                    "Toutes les composantes ont été ajoutées"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.recette.composanteMenuIds = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "form-group mb-0" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "selCategoriesGEMRCN" } },
                                [_vm._v("Catégories GEMRCN")]
                              ),
                              _c("MultiSelect", {
                                attrs: {
                                  id: "selCategoriesGEMRCN",
                                  disabled: _vm.recette.lectureSeule,
                                  value: _vm.recette.gemrcnIds,
                                  items: _vm.gemrcn,
                                  placeholder: "Catégories GEMRCN...",
                                  emptyText:
                                    "Toutes les catégories ont été ajoutées"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.recette.gemrcnIds = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c("span", [
                            _c("i", [
                              _vm._v(
                                "Allergènes : " + _vm._s(_vm.texteAllergenes)
                              )
                            ])
                          ]),
                          _vm.recette.saisieAllergenesIncomplete
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v(
                                  "Attention, la liste des allergènes est peut-être incomplète car ils n'ont pas été renseignés pour un ou plusieurs ingrédients"
                                )
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-top": "15px",
                                "font-size": "0.8em"
                              }
                            },
                            [
                              _c("em", [
                                _vm._v(
                                  "L’affichage des allergènes est effectué à titre informatif. Chaque utilisateur du logiciel doit vérifier par lui-même la véracité de ces informations auprès du ou des fournisseurs de denrées alimentaires concernés."
                                ),
                                _c("br"),
                                _vm._v(
                                  " En cas d’erreur, l’utilisateur ne pourra pas engager la responsabilité de la société Agap’pro, éditrice du logiciel."
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm.listeDesUtilisations.length
                  ? _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v(" Utilisations ")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "card-content",
                          attrs: { "aria-expanded": "true" }
                        },
                        [
                          _c("div", { staticClass: "card-body" }, [
                            _c(
                              "div",
                              { staticClass: "col-xs-12" },
                              [
                                _vm._v(
                                  " Cette recette est utilisée comme ingrédient dans : "
                                ),
                                _c("VueFuse", {
                                  staticStyle: {
                                    "padding-left": "-10px",
                                    position: "absolute",
                                    width: "98%"
                                  },
                                  attrs: {
                                    placeholder:
                                      _vm.compTermeDeRechercheUtilisation,
                                    minMatchCharLength: 3,
                                    threshold: 0.1,
                                    list: _vm.listeDesUtilisations,
                                    keys: ["nom"],
                                    search: _vm.termeDeRechercheUtilisation
                                  },
                                  on: {
                                    "fuse-input-changed":
                                      _vm.getTermeDeRechercheUtilisation,
                                    "fuse-results-updated": _vm.retourRecherche,
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.currentItem = 0
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      position: "relative",
                                      top: "15px"
                                    }
                                  },
                                  [
                                    _vm.termeDeRechercheUtilisation
                                      ? _c("span", {
                                          staticClass:
                                            "fas fa-window-close ml-2",
                                          on: {
                                            click: function($event) {
                                              return _vm.effacerLaRecherche()
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    key: _vm.keyUtilisations,
                                    staticClass: "mt-2 usages",
                                    staticStyle: {
                                      "margin-top": "65px!important"
                                    }
                                  },
                                  _vm._l(_vm.filteredUtilisationList, function(
                                    recetteInList,
                                    i
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: i,
                                        staticClass: "card-list mr-2",
                                        staticStyle: { "margin-bottom": "10px" }
                                      },
                                      [
                                        _c("RecettePopUpIngredients", {
                                          staticStyle: {
                                            "line-height": "20px"
                                          },
                                          attrs: {
                                            estLien: _vm.lienRecetteActif,
                                            recetteId: recetteInList.id,
                                            recetteNom: recetteInList.nom,
                                            estDeclinaisonNonPersonnalisee:
                                              recetteInList.estUneDeclinaison &&
                                              !recetteInList.estDeclinaisonPersonnalisee
                                          },
                                          on: {
                                            "recette-enregistree": function(
                                              $event
                                            ) {
                                              return _vm.recetteEnregistree(
                                                { composant: recetteInList },
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }